import { useAppSelector } from '../redux/hooks';
import { selectedUnit } from '../redux/reducers/unitSlice';
import {
  resolveUnitBaseColor,
  unitConnectorColors,
  type UnitConnectorColors,
} from '../businessLogicService/StudentDashboardAux/getColorByUnit';

// Resolves the connector color classes for the currently selected unit (from redux).
export const useUnitConnectorColors = (): UnitConnectorColors => {
  const unit = useAppSelector(selectedUnit);
  return unitConnectorColors[resolveUnitBaseColor(unit?.name)];
};
